// extracted by mini-css-extract-plugin
module.exports = {"pill":"PillSelector_pill__jLHGb","selected":"PillSelector_selected__6e85r"};